import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { SelectStyles } from "app/routes/Calendar/EventForm/constants";
import FormItem from "app/components/inputs/FormItem";
import styles from "./styles.module.scss";

type CollectType = "online" | "offline" | "both";
type PaymentMethod = "online" | "offline";

interface PaymentMethodDropdownProps {
  collectType: CollectType;
  value: PaymentMethod;
  onChange: (_value: PaymentMethod) => void;
  stripeIntegrationEnabled?: boolean;
}

export default function PaymentMethodDropdown(props: PaymentMethodDropdownProps) {
  const { collectType, value, onChange, stripeIntegrationEnabled = true } = props;
  const { t } = useTranslation();

  const paymentMethodOptions = [
    ...(stripeIntegrationEnabled ? [{ value: "online" as PaymentMethod, label: t("Online") }] : []),
    { value: "offline" as PaymentMethod, label: t("Offline") },
  ];

  const selectedOption = paymentMethodOptions.find(
    (option) => option.value === value
  );

  const isDisabled = collectType !== "both" || paymentMethodOptions.length === 1;

  return (
    <FormItem className={styles.container}>
      <label>{t("Payment Method")}</label>
      <Select
        value={selectedOption}
        options={paymentMethodOptions}
        onChange={(option: any) => onChange(option.value)}
        isDisabled={isDisabled}
        isSearchable={false}
        styles={SelectStyles}
        className={styles.dropdown}
        classNamePrefix="payment-method-select"
      />
    </FormItem>
  );
}
